// 과제 제약사항상 .env를 사용하지 못하기 때문에 하드코딩
export const apiUrl = "https://www.pre-onboarding-selection-task.shop";
